import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import { LinkButtonSBProps } from '@/components/atoms/linkButton/LinkSB';
import RichTextFieldSB, {
  RichTextFieldSBProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { StrapiThemes } from '@/components/themeProviderUtils';

import { BlockWrapper } from '@/features/utils/BlockWrapper';

import Banner from './index';

export interface BannerStrapiProps {
  image: ImageSBProps;
  title: string;
  theme?: StrapiThemes;
  description: RichTextFieldSBProps;
  direction: 'column' | 'row' | null;
  buttons: LinkButtonSBProps[];
  countdownExpiry: string | null;
}

export function BannerStrapi({
  block,
  ...rest
}: BlockComponentModel<BannerStrapiProps>) {
  const { image, title, description, countdownExpiry, direction, theme } =
    block;

  return (
    <BlockWrapper {...rest} theme={theme?.themeKey}>
      <div data-tracker-section='banner'>
        <Banner
          items={block.buttons}
          description={
            description ? <RichTextFieldSB block={description} /> : ''
          }
          title={title}
          direction={direction}
          image={
            <ImageSB
              inner={{ classNames: { image: 'w-9' } }}
              block={{ ...image }}
            />
          }
          countdownExpiry={countdownExpiry}
        />
      </div>
    </BlockWrapper>
  );
}
